import tinycolor from 'tinycolor2';

export {};

export const getGradientColor = (
    color: string,
    originGradientColor:
        | {
              colors: { color: string; value: number }[];
              angle: number;
          }
        | null
        | '',
    themeType?: string,
) => {
    const colorObj = tinycolor(color);
    const { h, s, l } = colorObj.toHsl();
    let newL = themeType === '浅色调' ? l + 0.5 : l - 0.5;
    let newS = themeType === '深色调' ? s + 0.2 : s - 0.2;
    newL = newL > 1 ? 1 : newL < 0 ? 0 : newL;
    newS = newS > 1 ? 1 : newS < 0 ? 0 : newS;

    if (originGradientColor) {
        const newColors = originGradientColor.colors.map((item, index) => {
            const originColor = tinycolor(item.color);
            const alpha = originColor.getAlpha();
            // const { l } = originColor.toHsl();

            return {
                color: tinycolor({
                    ...tinycolor({ h, s, l }).toRgb(),
                    a: alpha,
                }).toHex8String(),
                value: item.value,
            };
        });

        return {
            colors: newColors,
            angle: originGradientColor.angle,
        };
    } else {
        return {
            colors: [
                {
                    color: tinycolor({ h, s, l }).toHex8String(),
                    value: 0,
                },
                {
                    color: tinycolor({
                        h,
                        s: newS,
                        l: newL,
                    }).toHex8String(),
                    value: 1,
                },
            ],
            angle: 45,
        };
    }
};

export const getJSONByUrl = async (url: string) => {
    const response = await fetch(url);

    if (!response.ok) {
        throw new Error('网络响应失败');
    }
    return response.json(); // 将响应解析为 JSON
};
